import {PROGRESS_STATUSES, UnknownError} from '../../../shared/symbols';

/** Unique identifier for the public request a demo state. */
export const publicRequestADemoStateUniqueIdentifier = '_PublicRequestADemoStateUniqueIdentifier_';

/** Describes the state of the public request a demo feature. */
export interface PublicRequestADemoStateModel {
  /** Contain a status of the sending request a demo form process. */
  sendRequestADemoFormStatus: PROGRESS_STATUSES;

  /** Contain the last error that occurs during the sending request a demo form process. */
  lastSendRequestADemoFormError: UnknownError;
}

/** Default values for the public request a demo state. */
export const publicRequestADemoStateDefaults: PublicRequestADemoStateModel = {
  sendRequestADemoFormStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  lastSendRequestADemoFormError: null,
};
